import type { RefObject } from "react";
import { atom } from "jotai";

export interface ScrollTarget {
  scrollToElement: () => void;
  performerRef: RefObject<HTMLElement> | null;
}

/**
 * Atom to allow any component to call handler for clicking mobile about button and scrolling down to mobile performer card
 */
export const scrollToPerformerCardAtom = atom<ScrollTarget>({
  scrollToElement: () => ({}) as unknown,
  performerRef: null,
});
